// Projects offered as an agency's, and the ones candidates recorded against it.
//
// An agency's own projects are its editable list, `projectsExecuted`. A project a candidate records
// against their agency link is held apart, on the agency company listing's
// `metadata.recordedProjects`, which only the server writes. The agency's admin can hide one; a
// hidden project is no longer offered, but stays recorded.

const valuesOf = map => (map && typeof map === 'object' ? Object.values(map).filter(Boolean) : []);

// Every project recorded on the listing, hidden ones too, newest first.
export const recordedProjectsOf = listing =>
  valuesOf(listing?.attributes?.metadata?.recordedProjects).sort((a, b) =>
    String(b?.recordedAt || '').localeCompare(String(a?.recordedAt || ''))
  );

// A recorded project in the shape of one of the agency's own, so every reader of an option treats
// both alike.
const asOption = project => ({
  id: project.id,
  name: project.name,
  label: project.name,
  description: project.description || '',
  link: project.link || '',
  rating: project.rating ?? null,
  technologiesUsed: Array.isArray(project.technologiesUsed)
    ? project.technologiesUsed.join(', ')
    : project.technologiesUsed || '',
  where: project.where || '',
  recorded: true,
});

// The agency's own projects followed by the recorded ones that are not hidden. The lists given are
// left unchanged.
export const agencyProjectOptions = (ownProjects, listingMetadata) => {
  const own = (Array.isArray(ownProjects) ? ownProjects : [])
    .filter(Boolean)
    .map(project => ({ ...project, label: project.name || project.value }));
  const recorded = valuesOf(listingMetadata?.recordedProjects)
    .filter(project => !project.hidden)
    .sort((a, b) => String(a?.recordedAt || '').localeCompare(String(b?.recordedAt || '')))
    .map(asOption);
  return [...own, ...recorded];
};

// An id for a project row the browser creates, sent with its recording so a recording sent twice
// is recorded once.
export const newClientProjectId = () => {
  const cryptoApi = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  if (cryptoApi && typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID();
  return `${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 12)}`;
};
